<template>
  <div>
    <v-layout wrap>
      <v-flex xs12 sm2 md3>
        <v-layout wrap justify-center>
          <template v-for="(photos, j) in storage.productId.photos">
            <v-flex
              :xs6="storage.productId.photos > 1 ? true : false"
              :key="j"
              v-if="j < 1"
              pa-1
              text-center
              align-self-center
            >
             <router-link
                  :to="
                    '/Seller/Orders/' +
                      storage.order_id +
                      '?prod=' +
                      storage._id
                  "
                >
              <v-img :src="mediaURL + photos" height="100px" contain>
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="#FF2323"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
             </router-link>
            </v-flex>
          </template>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm10 md9>
        <v-layout wrap justify-center fill-height>
          <v-flex xs12 sm9 md9 lg9 xl10 text-left>
            <v-layout wrap justify-start style="line-height: 16px" fill-height>
              <v-flex xs12 align-self-start>
                <!-- <span
                  style="
                    font-family: poppinsregular;
                    font-size: 12px;
                    color: #42af54;
                  "
                >
                  Order No : {{ storage.orderID }}
                </span> -->
              </v-flex>
              <v-flex xs12 align-self-start>
                <router-link
                  :to="
                    '/Seller/Orders/' +
                      storage.order_id +
                      '?prod=' +
                      storage._id
                  "
                >
                  <!-- <router-link :to="'/Seller/Orders/?id=' + storage._id + '&odr_id=' + storage.order_id"> -->
                  <span
                    style="
                      font-family: poppinsmedium;
                      font-size: 16px;
                      color: #000000;
                    "
                  >
                    {{ storage.name.slice(0, 25) }}
                    <span v-if="storage.name.length > 25">...</span>
                  </span>
                </router-link>
              </v-flex>
              <v-flex xs12 align-self-end>
                <span
                  style="
                    font-family: poppinslight;
                    font-size: 12px;
                    color: #42af54;;
                  "
                >
                  Qty: <span v-if="storage.quantity > 1"></span
                  >{{ storage.quantity }} pieces
                </span>
              </v-flex>
              <v-flex xs12 align-self-end>
                <span
                  style="
                    font-family: poppinssemibold;
                    font-size: 13px;
                    color: #000000;
                  "
                >
                  Rs. {{ storage.productTotalAmount.toFixed() }}
                </span>
              </v-flex>
              <v-flex xs12 align-self-end>
                <span
                  style="
                    font-family: poppinslight;
                    font-size: 12px;
                    color: #6c6c6c;
                  "
                  >Status :
                  <span class="text-capitalize"
                    ><b>{{ storage.productOrderStatus }}</b></span
                  ></span
                >
              </v-flex>
              <v-flex xs12 align-self-end>
                <span
                  style="
                    font-family: poppinslight;
                    font-size: 12px;
                    color: #6c6c6c;
                  "
                >
                  Date : {{ formatDate(storage.track_dateTime.ordered) }}
                </span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: ["storage"],
  data() {
    return {};
  },

  methods: {
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      day = day < 10 ? "0" + day : day;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
  },
};
</script>
:src="baseURL + 'files/get/' + photos[0]" //
